module.exports = __webpack_public_path__ + "static/media/user-avatar.35e5a71e.png";